import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchInternalOrders } from '@/api/orders';
import type { InternalOrderListResponse } from '@/api/orders/types';
import { buildInternalOrdersApiBody } from '../-utils/listParams';

export const internalOrderKeys = {
  all: ['cascade-tracing', 'internal-orders'] as const,
  list: (body: Record<string, unknown>) =>
    [...internalOrderKeys.all, 'list', body] as const,
};

export function internalOrdersQueryOptions(params: {
  page: number;
  limit: number;
  isArchived: boolean;
  sort?: string;
  filters?: Record<string, string[]>;
}) {
  const body = buildInternalOrdersApiBody(params);
  return queryOptions({
    queryKey: internalOrderKeys.list(body),
    queryFn: () => fetchInternalOrders(body),
    staleTime: 30_000,
  });
}

export function useInternalOrdersList(params: {
  page: number;
  limit: number;
  isArchived: boolean;
  sort?: string;
  filters?: Record<string, string[]>;
}) {
  const body = buildInternalOrdersApiBody(params);

  return useQuery({
    queryKey: internalOrderKeys.list(body),
    queryFn: () => fetchInternalOrders(body),
    staleTime: 30_000,
    refetchInterval: query => {
      const data = query.state.data as InternalOrderListResponse | undefined;
      const orders = data?.data ?? [];
      const hasProcessing = orders.some(
        o =>
          o.aiSummary?.docType?.status === 'PREPARING' ||
          o.aiSummary?.docType?.status === 'PROCESSING' ||
          o.aiSummary?.docContent?.status === 'PREPARING' ||
          o.aiSummary?.docContent?.status === 'PROCESSING' ||
          o.aiSummary?.scAnalysis?.status === 'PREPARING' ||
          o.aiSummary?.scAnalysis?.status === 'PROCESSING',
      );
      return hasProcessing ? 20_000 : false;
    },
  });
}
